import React, { useState } from 'react';
import styles from './ClipsList.module.css';

/**
 * Twitchクリップをページネーションで表示するコンポーネント
 * @param {object} props
 * @param {Array<object>} props.clips - 表示するクリップデータの配列
 * @param {string} props.clips[].id - クリップのID
 * @param {string} props.clips[].title - クリップのタイトル
 * @param {string} props.clips[].thumbnail_url - クリップのサムネイル画像URL
 * @param {string} props.clips[].video_url - クリップの視聴URL
 * @param {string} props.clips[].published_at - クリップの公開日時
 */
const TwitchClipsList = ({ clips }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6; // 1ページあたりのクリップ数

  if (!clips || clips.length === 0) {
    return null;
  }

  const totalPages = Math.ceil(clips.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentClips = clips.slice(startIndex, endIndex);

  return (
    <div className={styles.clipsListContainer}>
      <div className={styles.clipsGrid}>
        {currentClips.map((clip) => (
          <a href={clip.url} key={clip.id} target="_blank" rel="noopener noreferrer" className={styles.clipItem}>
            <img src={clip.thumbnail_url} alt={clip.title} className={styles.thumbnail} />
            <div className={styles.clipTitle}>{clip.title}</div>
            <div className={styles.clipFooter}>
              <div className={styles.clipViews}>視聴回数: {clip.view_count.toLocaleString()}</div>
              <div className={styles.clipDate}>{new Date(clip.created_at).toLocaleDateString('ja-JP', { year: 'numeric', month: 'numeric', day: 'numeric' })}</div>
            </div>
          </a>
        ))}
      </div>
      {totalPages > 1 && (
        <div className={styles.pagerDots}>
          {[...Array(totalPages)].map((_, dotIndex) => (
            <span
              key={dotIndex}
              className={`${styles.dot} ${dotIndex + 1 === currentPage ? styles.activeDot : ''}`}
              onClick={() => setCurrentPage(dotIndex + 1)}
              role="button"
              data-testid={`pagination-dot-${dotIndex + 1}`}
            ></span>
          ))}
        </div>
      )}
    </div>
  );
};

export default TwitchClipsList; 